<template>
  <div>
    <table v-if="Object.keys(orderStatistics).length" class="table table-sm table-hover table-bordered">
      <thead>
      <tr class="highlight text-center">
        <th></th>
        <th colspan="2" v-for="project in $AllProjects" :key="project.id">{{ project.title }}</th>
        <th colspan="2">Итого</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(recordName, index) in reportIndexes">
        <td>{{ recordName }}</td>
        <template v-for="project in $AllProjects">
          <td>
            <template
              v-if="orderStatistics[project.id] && orderStatistics[project.id][index] && orderStatistics[project.id][index].ids && orderStatistics[project.id][index].ids.length">
              <a href="#"
                 @click.prevent="mixinGoToRouter('searchOrder', {ordersId: orderStatistics[project.id][index].ids})">{{
                  orderStatistics[project.id][index].ids.length
                }}</a>
            </template>
            <template v-else>0</template>
          <td>{{
              orderStatistics[project.id] && orderStatistics[project.id][index] && orderStatistics[project.id][index].total || 0
            }}
          </td>
        </template>
        <td class="highlight">{{ orderStatistics.total[index] && orderStatistics.total[index].ids.length || 0 }}</td>
        <td class="highlight">{{ orderStatistics.total[index] && orderStatistics.total[index].total || 0 }}</td>
      </tr>
      </tbody>
      <tfoot>
      <tr class="highlight">
        <th>итого общее</th>
        <template v-for="project in $AllProjects">
          <th>
            {{ orderStatistics[project.id] && orderStatistics[project.id].total.ids.length || 0 }}
          </th>
          <th>
            {{ orderStatistics[project.id] && orderStatistics[project.id].total.total || 0 }}
          </th>
        </template>
        <th>{{ orderStatistics.total.total.ids.length }}</th>
        <th>{{ orderStatistics.total.total.total }}</th>
      </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  props: ['orders', 'selectedDivision', 'showNewOrders'],
  data() {
    return {
      reportIndexes: {},
      reportIndexesList: {
        division: {
          manual: 'ручные',
          site: 'с сайта'
        },
        all: {
          manual_msk: 'ручные МСК',
          site_msk: 'сайт МСК',
          manual_spb: 'ручные СПБ',
          site_spb: 'сайт СПБ',
          manual_regions: 'ручные регионы',
          site_regions: 'сайт регионы',
          manual_post: 'ручные почта',
          site_post: 'сайт почта',
          // manual: 'итого ручные',
          // site: 'итого сайта'
        }
      },
      orderStatistics: {},
    }
  },
  watch: {
    showNewOrders() {
      this.updateStatistics();
    }
  },
  computed: {
    $AllProjects() {
      const stores = this.$store.getters["platform/projects"].filter(
        s => s.id && s.is_active
      );
      return _.orderBy(stores, "id");
    },
  },
  mounted() {
    this.updateStatistics();
  },
  methods: {
    updateStatistics() {
      this.reportIndexes = {...this.reportIndexesList[this.selectedDivision == 0 ? 'all' : 'division']};
      if (this.selectedDivision == 0) {
        this.orderStatistics = this.orders.reduce((acc, o) => {
          if (o.status < 0) {
            return acc;
          }
          if (!this.showNewOrders && +o.status === 9999) {
            return acc;
          }
          let foundIndex = null;
          Object.keys(this.reportIndexes).forEach((nameIndex) => {
            if (foundIndex) return;
            switch (nameIndex) {
              case 'manual_msk':
                if (o.city_id === 1 && !o.site_order_id) {
                  foundIndex = nameIndex;
                }
                break;
              case 'site_msk':
                if (o.city_id === 1 && o.site_order_id) {
                  foundIndex = nameIndex;
                }
                break;
              case 'manual_spb':
                if (o.city_id === 2 && !o.site_order_id) {
                  foundIndex = nameIndex;
                }
                break;
              case 'site_spb':
                if (o.city_id === 2 && o.site_order_id) {
                  foundIndex = nameIndex;
                }
                break;
              case 'manual_regions':
                if (![1, 2].includes(o.city_id) && o.city_id !== 0 && !o.site_order_id) {
                  foundIndex = nameIndex;
                }
                break;
              case 'site_regions':
                if (![1, 2].includes(o.city_id) && o.city_id !== 0 && o.site_order_id) {
                  foundIndex = nameIndex;
                }
                break;
              case 'manual_post':
                if (o.city_id === 0 && !o.site_order_id) {
                  foundIndex = nameIndex;
                }
                break;
              case 'site_post':
                if (o.city_id === 0 && o.site_order_id) {
                  foundIndex = nameIndex;
                }
                break;
            }
          });

          if (foundIndex) {
            if (!acc[o.site_id]) {
              acc[o.site_id] = {total: {ids: [], total: 0}};
            }
            if (!acc[o.site_id][foundIndex]) {
              acc[o.site_id][foundIndex] = {ids: [], total: 0};
            }
            acc[o.site_id][foundIndex].ids.push(o.id);
            acc[o.site_id][foundIndex].total += o.price;
            acc[o.site_id].total.ids.push(o.id);
            acc[o.site_id].total.total += o.price;
          }

          // const index = o.site_order_id ? 'site' : 'manual';
          if (!acc.total[foundIndex]) {
            acc.total[foundIndex] = {ids: [], total: 0};
          }
          acc.total[foundIndex].ids.push(o.id);
          acc.total[foundIndex].total += o.price;
          acc.total.total.ids.push(o.id);
          acc.total.total.total += o.price;
          return acc;
        }, {
          total: {
            // manual: {ids: [], total: 0},
            // site: {ids: [], total: 0},
            total: {ids: [], total: 0},
          }
        });
        console.log(this.orderStatistics);
      } else {
        this.orderStatistics = this.orders.reduce((acc, o) => {
          if (!acc[o.site_id]) {
            acc[o.site_id] = {
              manual: {ids: [], total: 0},
              site: {ids: [], total: 0},
              total: {ids: [], total: 0}
            };
          }
          if (o.status > 2) {
            const index = o.site_order_id ? 'site' : 'manual';
            acc[o.site_id][index].ids.push(o.id);
            acc[o.site_id][index].total += o.price;
            acc[o.site_id].total.ids.push(o.id);
            acc[o.site_id].total.total += o.price;
            acc.total[index].ids.push(o.id);
            acc.total[index].total += o.price;
            acc.total.total.ids.push(o.id);
            acc.total.total.total += o.price;
          }
          return acc;
        }, {
          total: {
            manual: {ids: [], total: 0},
            site: {ids: [], total: 0},
            total: {ids: [], total: 0},
          }
        });
      }

    }
  }
}
</script>

<style scoped>
.highlight {
  background-color: #ffffc6;
}

.highlight.text-center th {
  text-align: center;
}
</style>
